import React from 'react';
import {Form, Formik} from 'formik';
import {useDispatch} from 'react-redux';
import {saveMultimedia} from 'shared/portfolio/actions/multimedia';

export interface Multimedia {
  _id: string;
  title: string;
  category: string;
  description: string;
  links: string[];
  month: number;
  year: number;
  parentCategory: string;
  previewUrls: string[];

  // not from the API, FE only
  editing?: boolean;
  new?: boolean;
  scrollTo?: boolean;
}

interface Props {
  initialValues: Multimedia;
  children: React.ReactNode;
  onSuccess?: () => void;
}

const MultimediaFormWrapper = ({initialValues, children, onSuccess}: Props) => {
  const dispatch = useDispatch();

  return (
    <Formik
      initialValues={initialValues}
      validate={(values) => {
        const errors: {
          category?: string;
          title?: string;
          description?: string;
          month?: string;
          year?: string;
          name?: string;
          links?: string[];
        } = {};

        if (!values.category) {
          errors.category = 'Category is required';
        }

        if (!values.title) {
          errors.title = 'Title is required';
        }

        if (!values.description) {
          errors.description = 'Description is required';
        }

        if ((!values.month && values.month !== 0) || values.month < 0 || values.month > 11) {
          errors.month = 'Month is required';
        }

        if (!values.year) {
          errors.year = 'Year is required';
        }

        if (!values.category) {
          errors.name = 'Category is required';
        }

        if (!values.links) {
          errors.links = [];
          errors.links[0] = 'Link is required';
        }

        if (values.links && values.links[0].trim().length === 0) {
          errors.links = [];
          errors.links[0] = 'Link is required';
        }

        return errors;
      }}
      onSubmit={async (values, formik) => {
        try {
          await dispatch(saveMultimedia(values));
          onSuccess?.();
        } catch (errors: $TSFixMe) {
          if (errors.links) {
            if (errors.badLinkIndex > 0) {
              formik.setFieldError(`links[${errors.badLinkIndex}]`, errors.links);
            } else {
              formik.setFieldError(`links.${values.links.length}`, errors.links);
            }
          }

          if (errors.year) {
            formik.setFieldError('year', errors.year);
          }
        }
      }}
    >
      <Form autoComplete="off">{children}</Form>
    </Formik>
  );
};

export default MultimediaFormWrapper;
